import axios from "axios";
import { baseUrl, apiKey } from "../config";

const EMPTY_DATA = {
  data: {
    data: [],
  },
};

class KbvPluginService {
  constructor() {}
  fetchLeaguesMatchesFull = async () => {
    try {
      const response = await axios.get(`${baseUrl}/leagues/hot`, {
        headers: {
          ["x-signature"]: apiKey,
        },
      });

      return response?.data?.data || null;
    } catch (error) {
      console.error(error);
      return { error: "Server error" };
    }
  };

  fetchBangKeoMatches = async (queryObject) => {
    try {
      const response = await axios.get(
        `${baseUrl}/leagues/league-in-bangkeo-v2`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          params: {
            search: queryObject.search,
            filter: queryObject.filter,
            fields: queryObject.fields,
            include: queryObject.include,
            searchInclude: queryObject.searchInclude,
            filterInclude: queryObject.filterInclude,
            fieldsInclude: queryObject.fieldsInclude,
            filterOdds: queryObject.filterOdds,
            status: queryObject.status,
            order: queryObject.order,
            page: queryObject.page,
            limit: queryObject.limit,
            showEmptyOdds: queryObject.showEmptyOdds,
          },
        }
      );

      const payload = {
        data: response.data,
      };
      return payload;
    } catch (error) {
      console.error(error);
      return { error: "Server error" };
    }
  };

  fetchBangKeoMatchesOld = async (queryObject) => {
    try {
      const response = await axios.get(
        `${baseUrl}/leagues/league-in-bangkeo`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
          params: {
            search: queryObject.search,
            filter: queryObject.filter,
            fields: queryObject.fields,
            include: queryObject.include,
            searchInclude: queryObject.searchInclude,
            filterInclude: queryObject.filterInclude,
            fieldsInclude: queryObject.fieldsInclude,
            filterOdds: queryObject.filterOdds,
            status: queryObject.status,
            order: queryObject.order,
            page: queryObject.page,
            limit: queryObject.limit,
            showEmptyOdds: queryObject.showEmptyOdds,
          },
        }
      );

      const payload = {
        data: response.data,
      };
      return payload;
    } catch (error) {
      console.error(error);
      return { error: "Server error" };
    }
  };


  fetchFavoritesPublic = async (queryObject) => {
    try {
      const params = new URLSearchParams({
        matchIds: queryObject.matchIds || "",
        leagueIds: queryObject.leagueIds || "",
        search: queryObject?.search || "",
        filter: queryObject?.filter || "",
        fields: queryObject?.fields || "",
        include: queryObject?.include || "",
        searchInclude: queryObject?.searchInclude || "",
        filterInclude: queryObject?.filterInclude || "",
        fieldsInclude: queryObject?.fieldsInclude || "",
        filterOdds: queryObject?.filterOdds || "",
        page: queryObject?.page || "",
        limit: queryObject?.limit || "",
      });

      const response = await fetch(`${baseUrl}/user/favorites?${params}`, {
        headers: {
          "x-signature": apiKey,
        },
      });

      if (!response.ok) {
        console.error("Network response was not ok");
        return {};
      }

      const data = await response.json();
      return {
        data: data,
      };
    } catch (error) {
      console.error(error);
      return { error: "Server error" };
    }
  };

  getAllLeagues = async ({ fields }) => {
    try {
      const response = await axios.get(`${baseUrl}/leagues`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        params: {
          fields,
        },
      });

      return response?.data?.data || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getRoundsByLeagueId = async (leagueId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/leagues/${leagueId}/rounds`,
        {
          headers: {
            ["x-signature"]: apiKey,
          },
        }
      );

      return response?.data?.data || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getHotLeagues = async ({ page = 1, limit = 20, fields = "" }) => {
    try {
      const response = await axios.get(`${baseUrl}/leagues/hot`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        params: {
          page,
          limit,
          fields,
        },
      });

      return response;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  fetchMatchesByGroupRound = async (queryObject) => {
    try {
      const response = await axios.get(`${baseUrl}/matches`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        params: {
          filter: queryObject.filter,
          fields: queryObject.fields,
          include: queryObject.include,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });

      return {
        data: response?.data || null,
      };
    } catch (error) {
      console.error(error);
      return { data: null, error: "Server error" };
    }
  };

  getLeagueBySlug = async (slug) => {
    try {
      const response = await axios.get(`${baseUrl}/leagues/slug/${slug}`, {
        headers: {
          ["x-signature"]: apiKey,
        },
      });

      return response?.data?.data || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  getLeagues = async (params) => {
    try {
      const response = await axios.get(`${baseUrl}/leagues`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        params,
      });
      return response?.data?.data || [];

    } catch (error) {
      console.error(error);
      return [];
    }
  }
  getHotLeagues = async (params) => {
    try {
      const response = await axios.get(`${baseUrl}/leagues/hot`, {
        headers: {
          ["x-signature"]: apiKey,
        },
      });
      return response?.data?.data || [];

    } catch (error) {
      console.error(error);
      return [];
    }
  }
  getLeagueStandings = async (leagueId) => {
    try {
      const response = await axios.get(`${baseUrl}/standing`, {
        headers: {
          ["x-signature"]: apiKey,
        },
        params: {
          leagueId,
        }
      });
      return response?.data?.data || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  getLeagueFixtures = async (params) => {
    try {
      const response = await axios.get(`/matches`, {
        params
      });

      return response?.data?.data || null;
    } catch (error) {
      console.error(error);
      return EMPTY_DATA;
    }
  }
}



const instance = new KbvPluginService();
export { instance as KbvPluginService };
